import { Maximize, SkipForward, Square } from "lucide-react";
import { tr } from "@/lib/i18n";
import { MuteToggle } from "@/components/Toggles";

const cls = "w-[3em] h-[3em] flex items-center justify-center bg-black/55 hover:bg-black/80 text-white transition-colors";
const icon = { width: "1.4em", height: "1.4em" };

export const HostControls = ({ lang, canSkip, onSkip, onEnd, showEnd }) => (
  <div className="absolute left-[1em] bottom-[1em] z-[70] flex gap-[0.5em] opacity-60 hover:opacity-100 transition-opacity">
    {canSkip && (
      <button data-testid="host-skip-button" title={tr(lang, "skip")} className={cls} onClick={onSkip}><SkipForward style={icon} /></button>
    )}
    <MuteToggle className={cls} iconClass="w-[1.4em] h-[1.4em]" />
    <button
      data-testid="host-fullscreen-button"
      title={tr(lang, "fullscreen")}
      className={cls}
      onClick={() => (document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen?.())}
    >
      <Maximize style={icon} />
    </button>
    {showEnd && (
      <button data-testid="host-end-game-button" title={tr(lang, "end_game")} className={cls} onClick={onEnd}><Square style={icon} /></button>
    )}
  </div>
);
